// main.jsx or index.js
import ReactDOM from "react-dom/client";
import AppRoutes from "./App";
import { AuthProvider } from "./Common/Configurations/AuthContext";
import { BrowserRouter } from "react-router-dom";

ReactDOM.createRoot(document.getElementById("root")).render(
  <BrowserRouter>
  <AuthProvider>
    <AppRoutes />
  </AuthProvider>
  </BrowserRouter>
);
